module.exports = __webpack_public_path__ + "static/img/indexShare.05b229e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/indexShare.png
// module id = /zGp
// module chunks = 65